export default __webpack_public_path__ + "static/media/cafe-waiting.c1bba6f3.jpg";